export default __webpack_public_path__ + "static/media/14.842e7586.png";